import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Customer} from '../../../model/CustomerModel';

@Component({
  selector: 'v-asm-customers-for-order',
  templateUrl: './asm-customers-for-order.component.html'
})
export class AsmCustomersForOrderComponent implements OnInit {
  @Input() customers: Customer[];

  @Output() customerSelectedEvent = new EventEmitter<Customer>();
  selectedCustomer: Customer;

  constructor() {
  }

  ngOnInit() {
  }

  selectCustomer(customer: Customer) {
    this.customerSelectedEvent.emit(customer);
    this.selectedCustomer = customer;
  }

  getIdTracking(index: number, customer: Customer) {
    return customer.uid;
  }
}
